const styles = theme => ({
    fDashText: {
        color: '#FFF ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '34px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '20px ! important'
    },

    select: {
        color: '#ffffff !important',
        width: '210px !important',
        background: '#131E2E',
    },

    inputColor: {
        color: '#ffffff !important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px ! important',
        fontWeight: 500
    },

    intSelText: {
        color: '#000 !important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '14px ! important',
        fontWeight: 500
    },

    cards: {
        backgroundColor: '#131E2E !important',
        color: '#fff !important',
        margin: '10px !important',
        borderRadius: '8px !important',
        // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Shadow effect
        // minWidth: '150px !important',
        textAlign: 'center !important',
        width: '150px !important',
        cursor: 'pointer' // srini - 09-01-2025
    },

    title: {
        color: '#fff ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '16px ! important',
        fontWeight: 500,
    },

    accTitle: {
        color: '#fff ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '24px ! important',
        fontWeight: 500,
    },

    amtText: {
        color: '#FFA500 !important',
        fontFamily: 'cardiuma-M !important',
        fontSize: '18px !important',
        fontWeight: 500,
        marginLeft: '10px !important',
    },

    updtdText: {
        color: '#fff ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '12px ! important',
        fontWeight: 500,
    },

    listPrimaryText: {
        color: '#999 !important',
        fontSize: '14px !important',
        fontWeight: '200 !important',
        fontFamily: "cardiuma-M !important",
    },

    listSecondaryText: {
        color: '#FFF !important',
        fontSize: '13px !important',
        fontWeight: '400 !important',
        fontFamily: "cardiuma-regular !important",
    },
    // srini - 22-01-25
    stageText: {
        color: '#FFD700 !important',
        fontSize: '13px !important',
        fontWeight: '400 !important',
        fontFamily: "cardiuma-regular !important",
    },

    button: {
        width: "150px !important", 
        height: "48px !important",
        color: "rgb(255, 255, 255) !important",
        backgroundColor: "rgb(244, 71, 72) !important",
        fontFamily: "cardiuma-M !important",
        fontSize: "14px !important",
        fontStyle: "normal !important",
        textTransform: "none !important",
        borderRadius: "4px !important",
    },
    // srini - 21-01-25
    srchFldTxt: {
        '& .MuiInputBase-root': {
            backgroundColor: '#131E2E !important',
            color: 'white !important',
            fontFamily: 'cardiuma-regular',
            fontSize: '15px'
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '131E2E !important',
        },
        '& .MuiInputLabel-root': {
            color: 'white !important',
            fontFamily: 'cardiuma-regular',
            fontSize: '14px',
        },
        '& .MuiInputBase-input': {
            color: 'white !important',
        },
        "@media only screen and (max-width: 1620px)": {
            width: '150px !important'
        },
        "@media only screen and (max-width: 1420px)": {
            width: '130px !important'
        },
        "@media only screen and (max-width: 1350px)": {
            width: '120px !important'
        },
    }
    
})

export default styles